import { useState } from 'react';

const newsletterFormUrl = 'https://readdy.ai/api/form/d9qsmlknlsngrm4lm5ag';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;

    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpField = formData.get('phone_alt');
    if (hpField && String(hpField).trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const payload = new URLSearchParams();
      payload.append('email', email.trim());

      const response = await fetch(newsletterFormUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* use raw responseText */ }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '订阅失败，请稍后重试';
        setErrorMsg(serverMsg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查连接后重试');
      setStatus('error');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-16">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-500/10 mx-auto mb-6">
          <i className="ri-mail-unread-line text-3xl text-primary-400"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          订阅黑网料简报
        </h2>
        <p className="text-foreground-500 mb-8 max-w-lg mx-auto">
          每周精选最具价值的内幕资讯，第一时间推送至您的邮箱。不错过任何一条深度爆料。
        </p>

        {status === 'success' ? (
          <div className="py-4 px-6 rounded-xl bg-primary-500/10 border border-primary-500/20 text-primary-300">
            <i className="ri-check-double-line mr-2"></i>
            订阅成功！请查收确认邮件。
          </div>
        ) : (
          <form
            id="newsletter-form"
            data-readdy-form="true"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入您的邮箱地址"
              required
              className="flex-1 px-4 py-3 rounded-lg bg-background-900 border border-background-700/60 text-foreground-200 text-sm placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 focus:ring-1 focus:ring-primary-500/30 transition-all duration-200"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="contact-form-hp"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap disabled:opacity-60"
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i> 提交中
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  <i className="ri-send-plane-line"></i> 立即订阅
                </span>
              )}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-sm text-primary-400">{errorMsg}</p>
        )}

        <p className="mt-4 text-xs text-foreground-600">
          我们尊重您的隐私，绝不泄露您的邮箱信息
        </p>
      </div>
    </section>
  );
}